// components/notifications/NotificationMention.tsx
"use client";

import { FC } from "react";
import NotificationItem, {
  NotificationAvatar,
  NotificationPageLink,
  NotificationWorkspaceLink,
} from "@/components/tailwind/notification/notificationItem";

interface NotificationMentionProps {
  createdByName: string; // e.g. "Atharv"
  createdById?: string;
  createdByEmail?: string;
  noteTitle?: string;
  noteId?: string;
  workspaceName: string;
  workspaceId?: string;
  createdAt: string;
  read?: boolean;
}

const NotificationMention: FC<NotificationMentionProps> = ({
  createdByName,
  createdById,
  createdByEmail,
  noteTitle,
  noteId,
  workspaceName,
  workspaceId,
  createdAt,
  read,
}) => {
  return (
    <NotificationItem
      icon={<NotificationAvatar name={createdByName} userId={createdById} email={createdByEmail} />}
      createdAt={createdAt}
      unread={!read}
      title={createdByName}
      message={
        <>
          Mentioned you in{" "}
          <NotificationPageLink noteId={noteId} title={noteTitle} /> inside{" "}
          <NotificationWorkspaceLink workspaceId={workspaceId} workspaceName={workspaceName} />
        </>
      }
    />
  );
};

export default NotificationMention;
